import React from "react";
import { Box, Heading, Text, VStack, List, ListItem, Link } from "@chakra-ui/react";

export default function TermsOfService() {
  return (
    <Box maxW="1000px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 24, md: 32 }}>
      <VStack spacing={6} align="start">
        <Link
          as="button"
          onClick={() => window.history.length > 1 ? window.history.back() : window.location.assign("/")}
          aria-label="Back"
          position="fixed"
          top={{ base: "84px", md: "96px" }}
          left={{ base: 4, md: 8 }}
          zIndex="sticky"
          bg="white"
          color="teal.600"
          fontWeight="semibold"
          border="1px solid"
          borderColor="teal.100"
          borderRadius="full"
          px={{ base: 0, sm: 4 }}
          py={{ base: 0, sm: 2 }}
          w={{ base: "42px", sm: "auto" }}
          h={{ base: "42px", sm: "auto" }}
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="sm"
          _hover={{ textDecoration: "none", bg: "teal.50" }}
        >
          <Text as="span" display={{ base: "inline", sm: "none" }}>←</Text>
          <Text as="span" display={{ base: "none", sm: "inline" }}>← Back</Text>
        </Link>
        <Heading as="h1" size="xl" mb={4} mt={16}>
          Terms and Conditions
        </Heading>

        <Text color="gray.600">Effective Date: February 3, 2026</Text>

        <Heading as="h2" size="md" mt={4}>
          Introduction
        </Heading>
        <Text>
          Welcome to the official website of Swift Credit – https://swiftcredit.co (“Company”, “we,” “us”, or “our”). These Terms & Conditions (“Terms”) govern your access to and use of our website, products, and services (“platform”). By visiting, accessing, or using our platform, you (“User”, “you”, or “your”) acknowledge to have fully read these Terms and agree to be legally bound by them. If you do not agree to these Terms, you must immediately discontinue the use of our platform.
        </Text>
        <Text>
          Please note that these Terms represent the entire agreement between you and Swift Credit, superseding any prior agreements, representations, or understandings regarding our services. These Terms establish a legally binding agreement between you and Swift Credit. You must read and understand all provisions before interacting and engaging with our platform. You confirm that you have the legal capacity to enter into a binding contract and the information you provide is accurate and current. Using our platform, you confirm that you have read, understood, and agreed to these Terms. If you require further clarification regarding any section of this agreement, we encourage you to seek independent legal counsel before continuing to use our platform.
        </Text>
        <Text>
          Also, your continued use of our platform signifies your acceptance of these Terms and your agreement with our Privacy Policy. Failure to comply with these Terms may result in your account’s immediate suspension or termination, and Swift Credit reserves the right to take legal action where necessary.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Eligibility
        </Heading>
        <Text>
          To be eligible to use our platform, you must be a legal resident of at least one province in Canada; and be at least 18 years of age or the age of majority in your jurisdiction of residence.
        </Text>
        <Text>
          We reserve the right to verify your eligibility at any time. Failure to meet these criteria may result in suspension or termination of access to our platform. Also, we may require documentation or proof of eligibility and reserve the right to refuse service to individuals who do not comply with these requirements.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Permitted Use of our Platform
        </Heading>
        <Text>Our platform is intended for lawful and authorized use only. Users must not:</Text>
        <List pl={6} styleType="disc" spacing={2}>
          <ListItem>Violate applicable municipal, provincial, or federal laws while using our platform.</ListItem>
          <ListItem>Engage in activities that disrupt or interfere with its functionality.</ListItem>
          <ListItem>Transmit spam, malware, viruses, Trojan horses, or attempt unauthorized access to our systems.</ListItem>
          <ListItem>Misrepresent identity or impersonate another individual or entity.</ListItem>
          <ListItem>Engage in fraudulent activities or attempt to bypass authentication protocols.</ListItem>
        </List>
        <Text>
          Users must maintain the security of their login credentials and notify us promptly of any suspicious activity related to their accounts. Unauthorized access, including but not limited to hacking attempts, data breaches, phishing, fraudulent transactions, or other related activities will result in immediate termination of access and potential legal consequences.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Communications and Privacy
        </Heading>
        <Text>
          All electronic communications between users and Swift Credit, including emails and text messages are confidential. Users are strictly prohibited from collecting, distributing, or misusing email address(es) or phone number(s) obtained through our platform.
        </Text>
        <Text>
          Please refer to our Privacy Policy for comprehensive details on how we collect, process, and protect personal information. We may collect certain personal information as part of our service provision, and you consent to our collection and use of such information per applicable federal or provincial privacy laws.
        </Text>
        <Text>By submitting a loan application, you agree to receive contacted by Swift Credit through email, text, or call about your application.</Text>

        <Heading as="h2" size="md" mt={4}>
          Disclosure of Information
        </Heading>
        <Text>
          We may disclose aggregated information about you and such information will not identify any individual. Personal information may be disclosed with your consent; to fulfil the purpose for which you provided the information; to subsidiaries, affiliates, contractors, service providers, and other third parties we may use to support our platform.
        </Text>
        <Text>
          We may also disclose your information to a buyer or successor in the event of a merger, divestiture, restructuring, reorganization, dissolution, sale or transfer of some or all assets.
        </Text>
        <Text>
          Additionally, your personal information may be disclosed under the following conditions; however, in such cases we shall reasonably notify you in writing when we have to comply with a court order, law, or legal process, including any government or regulatory request; and when we believe that such disclosure is necessary or appropriate to protect its rights, property, or safety or that of its customers or agents. This may include the exchange of information with other companies for the purposes of credit risk or fraud protection.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Intellectual Property Rights
        </Heading>
        <Text>
          The content on our platform, including but not limited to design, texts, graphics, scripts, source code, API, photos, images, video, information, audio and other files, and all software used to provide our services, including all trademarks, copyright, patent, service marks, and logos contained therein (collectively, “Intellectual Property”), are the proprietary property of Swift Credit. Our Intellectual Property may not be modified, copied, distributed, framed, reproduced, republished, downloaded, scraped, displayed, posted, transmitted, sold, or exploited for any purpose in any form or by any means, in whole or in part, other than as expressly permitted under our terms. You shall not whether directly or indirectly, reverse engineer, decompile, disassemble, or otherwise attempt to derive source code or other trade secrets from any of our Intellectual Property. Any use of our Intellectual Property, other than as specifically authorized herein, is prohibited. We will automatically terminate your rights to use our services and any of our Intellectual Property. All rights to use our Intellectual Property that are not expressly granted in this Agreement are reserved by us.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Prohibited Conduct
        </Heading>
        <Text>You are prohibited from using our platform:</Text>
        <List pl={6} styleType="disc" spacing={2}>
          <ListItem>for any unlawful purpose;</ListItem>
          <ListItem>to solicit others to perform or participate in any unlawful acts;</ListItem>
          <ListItem>
            to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability;
          </ListItem>
          <ListItem>
            to submit false or misleading information; to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances;
          </ListItem>
          <ListItem>to infringe upon or violate our intellectual property rights or the intellectual property rights of others;</ListItem>
          <ListItem>
            to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of our platform or any related website, other websites, or the Internet;
          </ListItem>
          <ListItem>to collect or track the personal information of others; to spam, phish, pharm, pretext, spider, crawl, or scrape;</ListItem>
          <ListItem>for any obscene or immoral purpose; or to interfere with or circumvent the security features of our Website.</ListItem>
        </List>
        <Text>
          We reserve the right to terminate your use of and access to our platform for violating any of the prohibited conduct. Swift Credit reserves the right to investigate suspicious or inappropriate activities and take necessary actions, including notifying law enforcement agencies where required, and our right to terminate shall be based on careful investigation and conclusion of such prohibited uses.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Account Security and User Responsibilities
        </Heading>
        <Text>
          As a User, you are fully responsible for maintaining the security of your login credentials. Any actions taken using a user’s account shall be deemed the account holder’s responsibility. If you suspect unauthorized access, you must notify us immediately.
        </Text>
        <Text>Swift Credit shall not be liable for losses arising from negligence in safeguarding account information.</Text>
        <Text>To maintain security, users are encouraged to use strong passwords, enable multi-factor authentication, and regularly update their account details.</Text>

        <Heading as="h2" size="md" mt={4}>
          Third-Party Sites
        </Heading>
        <Text>
          For your convenience, our platform may provide links or pointers to third-party sites. We make no representations about any other website, applications, services, or systems that may be accessed from our platform. If you choose to access any such sites, you do so at your own risk. We have no control over the contents of any such third-party sites and accept no responsibility for such sites or for any loss or damage that may arise from your use of them. You are subject to any terms and conditions of such third-party sites.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Accuracy
        </Heading>
        <Text>
          We are not responsible if the information or content made available on our platform is not accurate, complete or current. Our platform is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this platform is at your own risk. We reserve the right to modify the contents of our platform at any time. You agree that it is your responsibility to monitor changes.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Warranties and Indemnification
        </Heading>
        <Text>
          You shall indemnify us against claims, damages, liabilities, costs, and expenses (including reasonable attorneys’ fees) that result from any authorized use of our platform, or from any breach of our representations, warranties, or obligations.
        </Text>
        <Text>
          You shall indemnify us, including licensees, sub-licensees, employees, agents, and assignees against claims, damages, liabilities, costs, and expenses (including reasonable attorneys’ fees) that result from any breach of representations, warranties, or obligations.
        </Text>
        <Text>If a claim is made against us arising out of the use of our services, you agree to cooperate fully, as needed, to defend against it.</Text>
        <Text>
          No oral or written information or advice provided by us, our officers, employees, agents or third-party providers will constitute legal or financial advice; or create a warranty of any kind with respect to our services or our platform.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Limitation of Liability
        </Heading>
        <Text>
          To the maximum extent permitted by law, we do not give warranties as to the accuracy, completeness, uninterrupted, or error-free operation of our platform. Also, we are not liable for any direct, indirect, incidental, or consequential damages arising from our platform malfunctions or disruptions, unauthorized access to user accounts, your reliance on this platform content, or loss of data or financial losses incurred due to service interruptions.
        </Text>
        <Text>
          You agree to indemnify Swift Credit against any claims resulting from your misuse of our services, ensuring that any unauthorized or inappropriate use does not result in legal or financial liability for us.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Dispute Resolution and Governing Law
        </Heading>
        <Text>
          These Terms and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the provincial laws of Ontario and the federal laws of Canada. Whether or not you used our platform, by entering into these Terms, you agree that you and Swift Credit shall both waive any right to trial by jury in any lawsuit, counterclaim, arbitration or any other proceeding. Furthermore, you are also waiving the right to be represented or participate in any representative class action of any kind.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Severability
        </Heading>
        <Text>
          In the event that any provision of these Terms is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms, such determination shall not affect the validity and enforceability of any other remaining provisions.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Amendments to Terms
        </Heading>
        <Text>
          We reserve the right to revise these Terms without prior notice. Your continued use of our platform following any modifications constitutes acceptance of the updated Terms. You are encouraged to periodically check this page and the “Effective Date” for the recent updates to our Terms. If at any time, you do not agree to the revised Terms, you must discontinue use of our platform immediately.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Contact Information
        </Heading>
        <Text>For inquiries, customer support, or clarification regarding these Terms, you may contact us at:</Text>
        <Text>Email: support@swiftcredit.co</Text>
        <Text>Address: Swift Credit</Text>
        <Text>10060 Jasper Ave, Tower 1, Suite 2020</Text>
        <Text>Edmonton, AB T5J 3R8</Text>
      </VStack>
    </Box>
  );
}
